import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const InvoiceModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.58579 2.58579C4.22386 2.94772 4 3.44772 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 3.44772 19.7761 2.94772 19.4142 2.58579L18 4L16 2L14 4L12 2L10 4L8 2L6 4L4.58579 2.58579Z"
            fill="url(#paint0_linear_227_654)"
          />
          <rect x="6" y="17" width="7" height="1" rx="0.5" fill="#1C0558" />
          <rect x="13" y="7" width="5" height="1" rx="0.5" fill="#1C0558" />
          <rect x="13" y="10" width="5" height="1" rx="0.5" fill="#1C0558" />
          <rect x="6" y="14" width="12" height="1" rx="0.5" fill="#1C0558" />
          <path
            d="M7.96495 7.11C7.38421 7.12556 7.09384 7.32259 7.09384 7.70111C7.09384 8.05889 7.37903 8.31037 7.9494 8.45556L7.95717 8.46333C7.96236 8.46333 7.96754 8.46333 7.97273 8.46333C7.98828 8.46852 8.00125 8.46593 8.01162 8.45556C8.02199 8.44 8.02717 8.42444 8.02717 8.40889V7.18C8.02717 7.13333 8.00643 7.11 7.96495 7.11ZM8.05051 10.8822C8.60532 10.8459 8.88273 10.6204 8.88273 10.2056C8.88273 10.0137 8.82051 9.85556 8.69606 9.73111C8.57162 9.60667 8.35384 9.50037 8.04273 9.41222C8.00125 9.40185 7.98051 9.41741 7.98051 9.45889V10.82C7.98051 10.8615 8.00384 10.8822 8.05051 10.8822ZM7.21051 9.14C6.45347 8.81333 6.07495 8.3337 6.07495 7.70111C6.07495 7.26556 6.2331 6.92074 6.5494 6.66667C6.87088 6.41259 7.34273 6.28296 7.96495 6.27778C8.00643 6.27778 8.02717 6.25444 8.02717 6.20778V5.88889C8.02717 5.78 8.06347 5.68926 8.13606 5.61667C8.21384 5.53889 8.30717 5.5 8.41606 5.5C8.52495 5.5 8.61569 5.53889 8.68828 5.61667C8.76606 5.68926 8.80495 5.78 8.80495 5.88889V6.26222C8.80495 6.29852 8.82569 6.32185 8.86717 6.33222C9.01236 6.34778 9.15495 6.37111 9.29495 6.40222C9.42458 6.42815 9.52828 6.49296 9.60606 6.59667C9.68903 6.70037 9.73051 6.81963 9.73051 6.95444V6.97778C9.73051 7.08667 9.68643 7.17222 9.59828 7.23444C9.51532 7.29148 9.4194 7.30704 9.31051 7.28111C9.16014 7.23963 9.01236 7.20852 8.86717 7.18778C8.82569 7.17741 8.80495 7.19556 8.80495 7.24222V8.61111V8.65C8.79458 8.69148 8.81014 8.72259 8.85162 8.74333C9.24051 8.90926 9.51532 9.1063 9.67606 9.33444C9.84199 9.56259 9.92495 9.84778 9.92495 10.19C9.92495 10.6619 9.76421 11.03 9.44273 11.2944C9.12643 11.5537 8.65717 11.6937 8.03495 11.7144C7.99865 11.7144 7.98051 11.7378 7.98051 11.7844V12.1111C7.98051 12.22 7.94162 12.3107 7.86384 12.3833C7.79125 12.4611 7.70051 12.5 7.59162 12.5C7.48273 12.5 7.3894 12.4611 7.31162 12.3833C7.23903 12.3107 7.20273 12.22 7.20273 12.1111V11.7456C7.20273 11.7041 7.1768 11.6781 7.12495 11.6678C6.97458 11.647 6.80865 11.6107 6.62717 11.5589C6.50273 11.5226 6.40162 11.45 6.32384 11.3411C6.25125 11.227 6.21495 11.1026 6.21495 10.9678V10.9056C6.21495 10.807 6.25643 10.7293 6.3394 10.6722C6.42754 10.6152 6.51828 10.6074 6.61162 10.6489C6.78791 10.7215 6.96162 10.7759 7.13273 10.8122C7.14828 10.8174 7.16384 10.8148 7.1794 10.8044C7.19495 10.7889 7.20273 10.7733 7.20273 10.7578V9.38889C7.20273 9.32148 7.2131 9.26704 7.23384 9.22556C7.25458 9.18407 7.2468 9.15556 7.21051 9.14Z"
            fill="#1C0558"
          />
          <defs>
            <linearGradient
              id="paint0_linear_227_654"
              x1="12"
              y1="7"
              x2="12"
              y2="22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A680FF" />
              <stop offset="1" stop-color="#4FFF8C" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default InvoiceModule;
